"use strict";
/**
 * 版本号比较
 *
 * ### Example
 * ```
 * const result1 = compareVersion('7.4.1', '7.5.0');  // -1
 * const result2 = compareVersion('7.5.0', '7.4.1');  // 1
 * const result3 = compareVersion('7.4.1', '7.4.1');  // 0
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function compareVersion(semVerA, semVerB) {
    if (semVerA === semVerB || !semVerA || !semVerB) {
        return 0;
    }
    var arrA = semVerA.split('.');
    var arrB = semVerB.split('.');
    var lenA = arrA.length;
    var lenB = arrB.length;
    for (var i = 0, len = Math.min(lenA, lenB); i < len; i++) {
        var numA = parseInt(arrA[i]);
        var numB = parseInt(arrB[i]);
        isNaN(numA) && (numA = 0);
        isNaN(numB) && (numB = 0);
        if (numA !== numB) {
            return numA > numB ? 1 : -1;
        }
    }
    return lenA > lenB ? 1 : lenA < lenB ? -1 : 0;
}
exports.compareVersion = compareVersion;
